import { socialShare } from '../socialShare/socialShare'
const $ = jQuery.noConflict()

export const mediaSearch = () => {
  const form = document.querySelector('.page_media.communique .search_filter_molecule')
  const container = document.querySelector('.articles_container .list_articles .item-list')
  if (form) {
    form.addEventListener('submit', async (e) => {
      container.innerHTML = '<p>Recherche en cours ...</p>'
      e.preventDefault()
      const lang = document.querySelector('html').getAttribute('lang')
      const inputValue = document.querySelector('.page_media.communique .search_filter_molecule .input_field input').value
      // const year = document.querySelector('.select2 .select2-selection__rendered').innerHTML
      const url = `/custom-search/api?keys=${inputValue}&language=${lang}&search=media&year=`
      const data = await fetch(url)
      const htmlResult = await data.text()
      container.innerHTML = htmlResult
      socialShare()
    })
  }

  if ($('.select-com')) {
    $('.select-com').on('change', async function (e) {
      const year = e.target.value
      document.querySelector('.page_media.communique .search_filter_molecule .input_field input').value = ''

      const lang = document.querySelector('html').getAttribute('lang')
      const url = `/custom-search/api?keys=&language=${lang}&search=media&year=${year}`
      const data = await fetch(url)
      const htmlResult = await data.text()
      container.innerHTML = htmlResult
      socialShare()
    })
  }
}
